<template>
	<div class="group-notifications-wrapper">
		<div :class="{ 'main-settings-override': prop_bubble_id }">
			<div
				v-if="prop_bubble_id"
				class="close-group-override"
				@click="closeOverride()"
			>
				<img
					class="icon-button"
					src="/images/common/large-grey-close.png"
					:alt="$t('common_button_back')"
				/>
			</div>

			<div v-if="prop_bubble_id" class="group-title-header">
				{{ bubble.displayname }}
			</div>

			<GroupMutePage v-if="muted" :bubble_id="prop_bubble_id" />

			<div v-if="!muted" class="unmuted">
				<MuteModal
					v-if="showMuteGroup"
					:group="true"
					:bubble_id="prop_bubble_id"
					@close="closeMute"
				/>

				<NotifyMe
					:group="bubble_id"
					:isdm="bubble.isdm && !bubble.isMultiDM"
					style="margin-bottom: 50px;"
				/>

				<div class="additional-notifications-section">
					<div
						class="title-wrapper"
						:class="{ 'zero-height': notifyMeSelected === 'NONE' }"
					>
						<div class="additional-notifications-title">
							{{ $t('settings_notifications_section_additional') }}
						</div>
					</div>

					<div class="additional-controls">
						<div
							class="everyone-setting control-transition"
							:class="{
								'zero-height': notifyMeSelected === 'NONE' || !mentionsSelected,
							}"
						>
							<ToggleBox
								:title="
									$t('settings_notification_prefs_allow_mention_everyone')
								"
								@checkedEvent="mentionsCheckedEvent"
								:toggleChecked="includeEveryone"
								:spinner="includeSpinner"
								:class="{ 'more-right-padding': prop_bubble_id }"
								data-cy="toggle-everyone"
							/>
						</div>

						<div
							class="other-settings control-transition"
							:class="{ 'zero-height': notifyMeSelected === 'NONE' }"
						>
							<ToggleBox
								:title="$t('groupsettings_mediatray_meetings_title')"
								@checkedEvent="notificationsCheckedEvent('meetings', $event)"
								:toggleChecked="meetingsToggle"
								:spinner="toggleSpinners['meetings']"
								:class="{ 'more-right-padding': prop_bubble_id }"
								data-cy="toggle-meetings"
							/>
						</div>

						<div
							class="other-settings control-transition"
							:class="{ 'zero-height': notifyMeSelected === 'NONE' }"
						>
							<ToggleBox
								:title="$t('groupsettings_mediatray_polls_title')"
								@checkedEvent="
									notificationsCheckedEvent(
										'polls_notifications_enabled',
										$event
									)
								"
								:toggleChecked="pollsToggle"
								:spinner="toggleSpinners['polls_notifications_enabled']"
								:class="{ 'more-right-padding': prop_bubble_id }"
								data-cy="toggle-polls"
							/>
						</div>
					</div>
				</div>

				<div v-show="notifyMeSelected !== 'NONE'" class="light-break"></div>

				<div class="mute-section">
					<div class="left-section">
						<div class="mute-title">
							{{ $t('groupsettings_notifications_mute_group') }}
						</div>
						<div class="mute-description">
							{{ $t('groupsettings_notifications_mute_group_notmuted_footer') }}
						</div>
					</div>
					<Button class="mute-button" @click="showMuteModal">
						{{ $t('groupsettings_notifications_mute_action_title') }}
					</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store, {
	getMyMembershipForBubble,
	getChat,
	getCurrentChat,
} from '@/store'
import { post } from '@/helpers/api'
import NotifyMe from '@/components/NotifyMe'
import ToggleBox from '@/components/ToggleBox'
import MuteModal from '@/components/MuteModal'
import GroupMutePage from '@/components/GroupMutePage'
import Button from '@/components/common/Button'
export default {
	props: ['prop_bubble_id'],

	components: {
		NotifyMe,
		ToggleBox,
		MuteModal,
		GroupMutePage,
		Button,
	},

	data() {
		return {
			store,
			bubble: null,
			muteToggle: false,
			toggleSpinners: {},
			includeSpinner: false,
			snoozePeriod: '',
			snoozeOptions: [
				this.$tc('accessibility_minutes_label.variable', 20, { Count: 20 }),
				this.$tc('accessibility_hours_label.variable', 1, { Count: 1 }),
				this.$tc('accessibility_hours_label.variable', 2, { Count: 2 }),
				this.$tc('accessibility_hours_label.variable', 4, { Count: 4 }),
				this.$tc('accessibility_hours_label.variable', 8, { Count: 8 }),
				this.$tc('accessibility_hours_label.variable', 24, { Count: 24 }),
			],
			isSnoozed: false,
			showMuteGroup: false,
		}
	},

	emits: ['close'],

	created() {
		this.bubble = this.prop_bubble_id
			? getChat(this.prop_bubble_id)
			: getCurrentChat()

		this.$onEventBus('chat-update', () => {
			this.bubble = this.prop_bubble_id
				? getChat(this.prop_bubble_id)
				: getCurrentChat()
		})
	},

	watch: {
		'bubble.mute': {
			handler(val, oldVal) {
				if (oldVal && !val) {
					this.muteToggle = false
					this.showMuteGroup = false
				}
			},
			deep: true,
		},

		snoozePeriod: function () {
			if (this.snoozePeriod) {
				this.isSnoozed = true
				this.snoozeChecked = true

				this.$nextTick(() => {
					this.setSnooze()
				})
			}
		},

		isSnoozed: function () {
			if (!this.isSnoozed) {
				this.snoozeOptions = [
					this.$tc('accessibility_minutes_label.variable', 20, { Count: 20 }),
					this.$tc('accessibility_hours_label.variable', 1, { Count: 1 }),
					this.$tc('accessibility_hours_label.variable', 2, { Count: 2 }),
					this.$tc('accessibility_hours_label.variable', 4, { Count: 4 }),
					this.$tc('accessibility_hours_label.variable', 8, { Count: 8 }),
					this.$tc('accessibility_hours_label.variable', 24, { Count: 24 }),
				]
			}
		},
	},

	computed: {
		bubble_id() {
			return this.bubble?.id
		},

		muted() {
			return this.bubble?.mute
		},

		notifyMeSelected() {
			return this.store.getNotificationPreference(this.bubble?.id)
		},

		membership() {
			return getMyMembershipForBubble(this.bubble?.id)
		},

		mentionsSelected() {
			return this.notifyMeSelected?.includes('MENTIONS') || false
		},

		includeEveryone() {
			return this.mentionsSelected && this.notifyMeSelected === 'MENTIONS'
				? true
				: false
		},

		meetingsToggle() {
			return this.membership?.meetings
		},

		pollsToggle() {
			return this.membership?.polls_notifications_enabled
		},
	},

	methods: {
		closeOverride() {
			this.$emit('close')
		},

		closeMute() {
			this.showMuteGroup = false
		},

		showMuteModal() {
			this.showMuteGroup = true
		},

		async notificationsCheckedEvent(field, isChecked) {
			const payload = {
				bubble_id: this.bubble.id,
				[field]: isChecked,
			}

			this.toggleSpinners[field] = true

			try {
				await post('/api/v1/membership.update', payload)
			} catch (e) {
				console.error(e)
			} finally {
				this.toggleSpinners[field] = false
			}
		},

		async mentionsCheckedEvent(isChecked) {
			if (!this.mentionsSelected) return
			const payload = {
				bubble_id: this.bubble.id,
				notificationpreference: isChecked ? 'MENTIONS' : 'MENTIONS_EXCLUDE_ALL',
			}

			this.includeSpinner = true

			try {
				await this.store.setNotificationPreference(true, payload)
			} catch (e) {
				console.error(e)
			}

			this.includeSpinner = false
		},
	},
}
</script>

<style scoped>
.group-notifications-wrapper {
	height: calc(100vh - 188px);
	min-height: 250px;
	overflow: auto;
	padding-right: 15px;
	padding-bottom: 32px;
}

.success-check {
	width: 17px;
	height: 12px;
	opacity: 0;
	position: absolute;
	transition: opacity 1s ease-out;
}

.zero-height {
	height: 0 !important;
	margin-top: 0 !important;
	overflow: hidden;
}

.control-transition {
	-webkit-transition: all 0.3s ease-in-out;
	-moz-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
}

.everyone-setting {
	height: 70px;
	overflow: hidden;
}

.other-settings {
	height: 70px;
	overflow: hidden;
}

:deep(.notify-me-section) {
	margin-top: 32px;
}

.main-settings-override {
	width: 830px;
	margin: 0 auto;
	position: relative;
}

.close-group-override {
	cursor: pointer;
	position: absolute;
	position: absolute;
	top: 10px;
}

.group-title-header {
	margin-top: 50px;
	margin-bottom: 50px;
	font-family: Avenir-Heavy;
	font-size: 30px;
	text-align: center;
}

.more-right-padding :deep(.togglebox) {
	padding-right: 25px;
}

.light-break {
	border-bottom: 1px solid var(--neutral-200);
	margin-top: 40px;
	margin-bottom: 40px;
}

.mute-section {
	display: flex;
	align-items: center;
}

.left-section {
	flex: 2;
}

.mute-title {
	font-family: Avenir-Heavy;
	font-size: 18px;
	margin-bottom: 9px;
}

.mute-description {
	font-family: Avenir-Medium;
	font-size: 14px;
	color: #8e8e8e;
	max-width: 310px;
}

.mute-button {
	width: 120px;
	justify-content: center;
}

.additional-notifications-section {
	display: flex;
}

.title-wrapper {
	flex: 1;
	height: 25px;
	margin-right: 10px;
}

.additional-notifications-title {
	font-family: Avenir-Heavy;
	font-size: 18px;
}

.additional-controls {
	flex: 1;
	min-width: 320px;
	max-width: 500px;
}
</style>
